import { Box, Stack, styled } from '@mui/material';
import { DeliveryStatus } from '@synergy/models';
import { PoolCardContent, PoolLineClampTypography, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { ArticleCardContentArticleNumber } from './article-card-content-article-number';
import { ArticleCardContentContentInfo } from '../components/article-card-content-content-info';
import { ArticleCardContentPriceInfo } from '../components/article-card-content-price-info';
import { ArticleCardContentSupplierInfo } from '../components/article-card-content-supplier-info';
import { SearchScoreOverlay } from '../search-score-overlay';
import { useArticleCardContext } from '../article-card';

const StyledContent = styled(PoolCardContent)(({ theme }) => ({
    minWidth: '203px', // Screen design
    padding: theme.spacing(2),
    paddingLeft: 0,
}));

export const ArticleCardContent = (): ReactElement => {
    const { article } = useArticleCardContext();

    return (
        <StyledContent>
            <Stack sx={{ height: '100%' }} gap={1.5}>
                <Box>
                    <PoolLineClampTypography variant="subtitle1" component="span" maxLines={3} sx={{ mb: 0.5 }}>
                        <strong>{article.name}</strong>
                    </PoolLineClampTypography>
                    {article.deliveryStatus !== DeliveryStatus.OnRequest ? (
                        <>
                            <ArticleCardContentArticleNumber />
                            <ArticleCardContentPriceInfo />

                            <ArticleCardContentContentInfo />
                        </>
                    ) : (
                        <PoolTypography variant="h5" translationId="app.article.priceOnRequest" />
                    )}
                </Box>

                <Box>
                    <ArticleCardContentSupplierInfo />
                </Box>
            </Stack>

            <SearchScoreOverlay score={article.score || 0} />
        </StyledContent>
    );
};
